import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled, { mediaQuery, css, academyPageFullWidth, academyResultsBar, theme } from 'academy-common-lib/utils/Styling';
import Heading from '../../../components/Layouts/Heading';
import { EditPlaylistButton, usePlaylist } from '..';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from '../../navigation';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Subheader = styled(_ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("nav", Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      justify: "between",
      children: children
    })
  }));
}).withConfig({
  displayName: "PlaylistPageHeader__Subheader",
  componentId: "sc-1drpepf-0"
})(["", " & > div{height:100%;", ";}padding-right:12px;padding-left:12px;", ";"], academyResultsBar, academyPageFullWidth, mediaQuery('notMobile', css(["padding-right:12px;padding-left:24px;"])));
const PlaylistBackButton = styled(BackButton).withConfig({
  displayName: "PlaylistPageHeader__PlaylistBackButton",
  componentId: "sc-1drpepf-1"
})(["color:", " !important;"], theme.colors.OLAF);
export const PlaylistPageHeader = ({
  playlistId
}) => {
  const {
    playlist
  } = usePlaylist(Number(playlistId));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.playlist"
      }),
      title: playlist ? playlist.name : ''
    }), /*#__PURE__*/_jsxs(Subheader, {
      children: [/*#__PURE__*/_jsx(PlaylistBackButton, {
        exact: true,
        to: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.myPlaylists"
        })
      }), /*#__PURE__*/_jsx(EditPlaylistButton, {
        $isHiddenFor: "notMobile",
        playlistId: playlistId
      })]
    })]
  });
};